import {
  createDocument,
  deleteDocument,
  getDocuments,
  updateDocument,
} from '../services/documents';

export type Profile = {
  name: string;
};

export type ProfileListResponse = {
  error: any;
  dynamicPricingList: Profile[];
};

export type GetProfileList = () => any;

export const getProfileList: GetProfileList = () =>
  getDocuments('dynamic-pricing');

export const deleteProfile = async (uuid: string) =>
  deleteDocument(uuid, 'dynamic-pricing');

export const createProfile = (profile: Profile) =>
  createDocument(profile, 'dynamic-pricing');

export const updateDynamicPricingDetail = (id, dynamicPricingDetail: any) => {
  return updateDocument(
    '',
    dynamicPricingDetail,
    `dynamic-pricing/${id}/detail`,
  );
};

export const getDynamicPricingDetail = (id: string) =>
  getDocuments(`dynamic-pricing/${id}/detail`);
